import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import MainComponentWrapper from "../../Components/Common/MainComponentWrapper";
import MainPagination from "../../Components/Common/MainPagination";
import Event from "../../Components/User/Events/Event";
import CustomLayoutUser from "../../Components/Layout/CustomLayoutUser";
import useHttpHook from "../../Hooks/HttpHook";
import {
  GetUserByName,
  getUserPromotingEvents,
} from "../../utils/ApiConstant";
import { createObjectForPaginatedResult } from "../../utils/Helper";
import { toast } from "react-toastify";
import { showErrorToast } from "../../utils/notify";

export function UserPromotingEvents() {
  const [loading, sendRequest, error] = useHttpHook();
  const [, fetchProfile] = useHttpHook();
  const [eventsList, setEventsList] = useState();
  const [profileUser, setProfileUser] = useState(null);
  const { userName } = useParams();
  const locationData = useLocation();

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  useEffect(() => {
    const stateProfile = locationData?.state?.userProfile;
    if (stateProfile) {
      setProfileUser(stateProfile);
      return;
    }

    if (!userName) {
      setProfileUser(null);
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const res = await fetchProfile(`${GetUserByName}/${userName}`, {
          method: "get",
        });
        if (!cancelled && res?.status === 1) {
          setProfileUser(res.data);
        }
      } catch (err) {
        console.log({ err });
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [fetchProfile, locationData?.state?.userProfile, userName]);

  const getEvents = useCallback(
    async (page = 1) => {
      if (!userName) return;
      const events = await sendRequest(
        `${getUserPromotingEvents}/${userName}?page=${page}`,
        {
          method: "get",
        }
      );
      if (page == 1) {
        setEventsList(events);
      } else {
        setEventsList((prevState) => {
          return createObjectForPaginatedResult(events, prevState);
        });
      }
    },
    [sendRequest, userName]
  );

  useEffect(() => {
    setEventsList(undefined);
    getEvents();
  }, [getEvents]);

  return (
    <CustomLayoutUser
      Heading="Promoting Events"
      TitleMark="Promoting"
      TitleMarkClassName="event-my-events-title-mark"
      TitleClassName="event-my-events-title"
      HeadClassName="event-my-events-head"
      ExtraclassName="event-my-events-panel"
      activeMenuId="user-promoting-events"
    >
      <MainComponentWrapper Loading={loading} errorInfo={error}>
        {eventsList?.data?.itemsList?.length > 0 ? (
          <MainPagination getEventsMethod={getEvents} MainData={eventsList}>
            <div
              className="event-cards-grid"
              role="list"
              aria-label="Promoting events"
            >
              {eventsList.data.itemsList.map(
                ({
                  _id,
                  title,
                  eventTiming,
                  category,
                  location,
                  mainimage,
                  wishlist,
                }) => (
                  <Event
                    key={_id}
                    userName={userName}
                    title={title}
                    eventTiming={eventTiming}
                    category={category}
                    location={location}
                    Id={_id}
                    mainimage={mainimage}
                    wishlist={wishlist}
                    userProfile={profileUser}
                  />
                )
              )}
            </div>
          </MainPagination>
        ) : (
          <div className="event-empty">
            <i className="bi bi-megaphone" aria-hidden="true"></i>
            <p>No promoting events found</p>
          </div>
        )}
      </MainComponentWrapper>
    </CustomLayoutUser>
  );
}
